export enum TransportPreference {
  UNSET_TRANSPORT_PREFERENCE = 'UNSET_TRANSPORT_PREFERENCE', // Do not use, needed because of proto3 limitations
  SMS_ONLY = 'SMS_ONLY',
  PUSH_PRIORITY = 'PUSH_PRIORITY',
  PUSH_ONLY = 'PUSH_ONLY',
  WHATSAPP_PRIORITY = 'WHATSAPP_PRIORITY',
  WHATSAPP_ONLY = 'WHATSAPP_ONLY',
}
